module.exports = __webpack_public_path__ + "static/media/step4.75130a63.svg";